module.exports = __webpack_public_path__ + "img/2.98541782.webp";